<template>
  <div class="home-container">
    <div class="banner container-fuild">
      <video
        class="video"
        src="../assets/img/home/home.mp4"
        autoplay
        muted
        playsinline="true"
        webkit-playsinline="true"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        controlslist="nofullscreen nodownload noremote footbar"
      />

      <div class="about-us" v-if="showTitle">
        <img
          class="t-img"
          src="../assets/img/home/solgan.png"
          alt="领先的数字营销赋能专家"
        />
        <div class="consult none">
          <input
            type="text"
            class="custom-input"
            placeholder="输入您想了解的问题"
          />
          <a
            class="call"
            href="https://affim.baidu.com/unique_45460827/chat?siteId=18857849&userId=45460827&siteToken=493919704d5aac29d6432775b0f6fb65"
            target="_blank"
          >
            点击咨询
          </a>
        </div>
      </div>

      <div class="text-swiper" v-show="showTitle">
        <div style="width: 100%; height: 100%; overflow: hidden">
          <div class="swiper-wrapper" :style="{ marginLeft: `-${mLeft}px` }">
            <div class="swiper-list">
              <div class="text-item">P&G</div>
              <div class="text-item">MARS</div>
              <div class="text-item">Vitasoy</div>
              <div class="text-item">Kraft Heinz</div>
              <div class="text-item">Henkel</div>
              <div class="text-item">Liby</div>
              <div class="text-item">Florasis</div>
              <div class="text-item">LEE KUM KEE</div>
              <div class="text-item">WL DELICIOUS</div>
              <div class="text-item">Nestlé</div>
              <div class="text-item">H&H Group</div>
              <div class="text-item">DANONE</div>
              <div class="text-item">Yili</div>
              <div class="text-item">Brightdairy</div>
              <div class="text-item">BYHEALTH</div>
              <div class="text-item">DARLIE</div>
              <div class="text-item">Carlsberg</div>
              <div class="text-item">Swellfun</div>
              <div class="text-item">Mondelez</div>
            </div>
            <div class="swiper-list">
              <div class="text-item">P&G</div>
              <div class="text-item">MARS</div>
              <div class="text-item">Vitasoy</div>
              <div class="text-item">Kraft Heinz</div>
              <div class="text-item">Henkel</div>
              <div class="text-item">Liby</div>
              <div class="text-item">Florasis</div>
              <div class="text-item">LEE KUM KEE</div>
              <div class="text-item">WL DELICIOUS</div>
              <div class="text-item">Nestlé</div>
              <div class="text-item">H&H Group</div>
              <div class="text-item">DANONE</div>
              <div class="text-item">Yili</div>
              <div class="text-item">Brightdairy</div>
              <div class="text-item">BYHEALTH</div>
              <div class="text-item">DARLIE</div>
              <div class="text-item">Carlsberg</div>
              <div class="text-item">Swellfun</div>
              <div class="text-item">Mondelez</div>
            </div>
          </div>
        </div>
      </div>
      <div class="indexBanner" v-if="showTitle">
        <!--一个BANNER 开始-->
        <!-- <div class="banner">
          <div class="about-us">
            <img
              class="t-img"
              src="../assets/img/home/title.png"
              alt="领先的数字营销赋能专家"
            />
            <div class="consult">
              <input
                type="text"
                class="custom-input"
                placeholder="输入您想了解的问题"
              />
              <a
                class="call"
                href="https://affim.baidu.com/unique_45460827/chat?siteId=18857849&userId=45460827&siteToken=493919704d5aac29d6432775b0f6fb65"
                target="_blank"
              >
                点击咨询
              </a>
            </div>
          </div>
        </div> -->
        <!--一个BANNER 结束-->

        <!--多个BANNER 开始-->
        <el-carousel
          ref="carouselRef"
          height="1349px"
          :interval="5000"
          arrow="never"
          trigger="click"
          autoplay
        >
          <el-carousel-item>
            <div class="banner">
              <div class="about-us">
                <img
                  class="t-img"
                  src="../assets/img/home/solgan.png"
                  alt="领先的数字营销赋能专家"
                />
                <div class="consult none">
                  <input
                    type="text"
                    class="custom-input"
                    placeholder="输入您想了解的问题"
                  />
                  <a
                    class="call"
                    @click="goExhibition()"
                  >
                    点击咨询
                  </a>
                </div>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="banner1" @click="goAI()"></div>
          </el-carousel-item>
        </el-carousel>
        <!--多个BANNER 结束-->
      </div>
    </div>

    <section
      class="modal-box"
      @mouseover="onMouseOverModalBox"
      @mousemove="onMouseMoveModalBox"
      @mousewheel="onMouseLeaveModalBox"
      @mouseleave="onMouseLeaveModalBox"
    >
      <img
        class="img-1"
        v-lazy="require('../assets/img/home/3a.png')"
        alt="3A模型"
      />
      <div class="mask-3a" v-show="showModalBigger"></div>
      <div class="bigger" v-show="showModalBigger">
        <img
          class="bigger-img"
          v-lazy="require('../assets/img/home/3a.png')"
          alt="3A模型"
        />
      </div>
      <div style="position: absolute; top: 0; opacity: 0">
        <h2>CYBER 3A 数字营销模型</h2>
        <h4>Application（系统应用·驱动引擎）</h4>
        <dl>
          <dt>精耕渠道</dt>
          <dd>客户数字化运营平台</dd>
          <dd>智能订货协同平台（B2B）</dd>
          <dd>销售能力自动化（SFA）</dd>
          <dd>智能会员运营体系</dd>
        </dl>
        <dl>
          <dt>赋能营销</dt>
          <dd>高阶数智化营销是费用管理（Cyber TPM）</dd>
          <dd>销售预测</dd>
          <dd>销售激励</dd>
        </dl>
        <h4>Analytics（决策分析·赋能引擎）</h4>
        <dl>
          <dt>激活业务</dt>
          <dd>主数据管理（MDM）</dd>
          <dd>全域数据洞察（BI）</dd>
        </dl>
        <dl>
          <dt>洞察市场</dt>
          <dd>新品研发·协同平台</dd>
          <dd>消费者意见洞察</dd>
          <dd>全域价格监测</dd>
        </dl>
        <h4>AI（智能算法·加速引擎）</h4>
        <ul>
          <li>营销归因与预测模型</li>
          <li>活动智能推荐模型</li>
          <li>销售预测模型</li>
          <li>价格策略模型</li>
          <li>成本预测模型</li>
          <li>竞品分析模型</li>
        </ul>
      </div>
    </section>
    <section class="solution-box none">
      <div class="box-content">
        <div
          class="strength-title"
          v-lazy:background-image="require('../assets/img/home/solutions.png')"
        >
          <div class="strength-color"></div>
          <div class="text">行业解决方案</div>
        </div>
        <div class="condition-box">
          <div
            class="condition-item"
            :class="[{ selected: item.name === solutionSelected }]"
            v-for="(item, index) in solutions"
            @click="onChangeSolution(item.name, null, index)"
            :key="item.name"
          >
            {{ item.name }}
            <div class="line"></div>
          </div>
        </div>
        <div class="solution-swiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide solution-item"
              v-for="(item, index) of solutions"
              :key="item.name"
            >
              <img class="cover" v-lazy="item.img" alt="cover" />
              <div class="solution-item__content">
                <h4 class="solution-item__title">
                  {{ item.name }}{{ item.name === "地产与石化" ? "" : "行业" }}
                  <br />数字赋能方案
                </h4>
                <div class="solution-item__btn" @click="goSolution">
                  查看详情
                  <div class="arrow-right"></div>
                </div>
                <div class="solution-item__arrow">
                  <div
                    @click="onChangeSolution(solutionSelected, 'prev')"
                    class="left"
                    :class="{ disabled: index === 0 }"
                  ></div>
                  <div
                    @click="onChangeSolution(solutionSelected, 'next')"
                    class="right"
                    :class="{ disabled: index === solutions.length - 1 }"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="customers-box">
      <div class="box-content">
        <div
          class="strength-title"
          v-lazy:background-image="require('../assets/img/home/customers.png')"
        >
          <div class="strength-color none"></div>
          <div class="text none">品牌企业数字化转型的共同选择</div>
        </div>
        <div class="clearfix"></div>
        <div
          class="brand-more"
          v-lazy:background-image="require('../assets/img/home/more.png')"
          @mouseover="showAll = true"
        ></div>
        <div class="brand-list">
          <div
            class="brand-item"
            v-for="(item, index) of brandData.list"
            :key="index"
          >
            <img
              class="brand-item__img"
              :class="`brand-logo-${item.id}`"
              v-lazy="item.img"
              alt="cover"
            />
          </div>
        </div>
        <div class="page">
          <div class="left">
            <span class="current">
              {{
                brandData.pageNum < 10
                  ? `0${brandData.pageNum}`
                  : brandData.pageNum
              }}
            </span>
            <span class="total">
              /{{
                brandData.pageTotal < 10
                  ? `0${brandData.pageTotal}`
                  : brandData.pageTotal
              }}
            </span>
          </div>
          <div class="middle">
            <span
              :class="{ selected: brandData.pageNum >= item }"
              v-for="item in brandData.pageTotal"
              :key="item"
            ></span>
          </div>
          <div class="right">
            <span class="prev" @click="onChangePage('prev')">
              <img
                v-lazy="require('../assets/img/industrySolutions/prev.png')"
                alt="prev"
              />
            </span>
            <span class="next" @click="onChangePage('next')">
              <img
                v-lazy="require('../assets/img/industrySolutions/next.png')"
                alt="next"
              />
            </span>
          </div>
        </div>
      </div>
      <div class="popup" v-show="showAll" @mouseleave="showAll = false">
        <div class="brand-list box-content">
          <div class="brand-item" v-for="(item, index) of brands" :key="index">
            <img
              class="brand-item__img"
              :class="`brand-logo-${item.id}`"
              v-lazy="item.img"
              alt="cover"
            />
          </div>
          <div
            class="brand-item-more none"
            @click="$router.push({ name: 'Contact' })"
          >
            <div class="arrow-left"></div>
            更多案例
          </div>
        </div>
      </div>
      
    </section>
    <section
      id="partners"
      class="partners-box none"
      v-lazy:background-image="
        require(`../assets/img/home/partners/${activeIndex}.png`)
      "
    >
      <div class="box-content">
        <div
          class="strength-title"
          v-lazy:background-image="require('../assets/img/home/partners.png')"
        >
          <div class="strength-color" :class="`bc-${activeIndex}`"></div>
          <div class="text">生态合作伙伴</div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="card">
        <div
          class="card-item"
          :class="{ active: activeIndex === 1 }"
          @click="activeIndex = 1"
        >
          <div class="card-item__left">
            <div class="left-top bg-f3">
              <img
                class="left-logo logo-1"
                v-lazy="require('../assets/img/home/partners/gray-1.png')"
                alt="中国电信"
              />
            </div>
            <div class="left-bottom ba-45">中国电信</div>
          </div>
          <div class="card-item__right">
            <div class="right-top">
              <h4 class="right-title">中国电信</h4>
              <p class="right-desc desc-1">
                中国电信集团有限公司是中国特大型通信运营企业，连续多年入选《财富》杂志“世界500强企业”，主要经营移动通信、互联网接入及应用、固定电话、卫星通信、ICT集成等综合信息服务。集团公司总资产9898亿元，员工39万人。
              </p>
              <img
                class="right-logo logo-1"
                v-lazy="require('../assets/img/home/partners/logo-1.png')"
                alt="中国电信"
              />
            </div>
            <div class="right-bottom bga-1"></div>
          </div>
        </div>
        <div
          class="card-item"
          :class="{ active: activeIndex === 2 }"
          @click="activeIndex = 2"
        >
          <div class="card-item__left">
            <div class="left-top" :class="`bg-f${activeIndex > 2 ? '9' : '3'}`">
              <img
                class="left-logo logo-2"
                v-lazy="require('../assets/img/home/partners/gray-2.png')"
                alt="交通银行"
              />
            </div>
            <div
              class="left-bottom"
              :class="`ba-${activeIndex > 2 ? '5' : '4'}5`"
            >
              交通银行
            </div>
          </div>
          <div class="card-item__right">
            <div class="right-top">
              <h4 class="right-title">交通银行</h4>
              <p class="right-desc desc-2">
                交通银行，简称BOCOM，创始于1908年，资产总额达人民币13.81万亿元，为中国六大银行之一，同时是中国历史最悠久的银行之一，也是近代中国的发钞行之一。1987年4月1日，重新组建后的交通银行正式对外营业，成为中国第一家全国性的国有股份制商业银行，总行设在上海。2005年6月交通银行在香港联合交易所挂牌上市，2007年5月在上海证券交易所成功挂牌上市。
              </p>
              <img
                class="right-logo logo-2"
                v-lazy="require('../assets/img/home/partners/logo-2.png')"
                alt="交通银行"
              />
            </div>
            <div class="right-bottom bga-2"></div>
          </div>
        </div>
        <div
          class="card-item"
          :class="{ active: activeIndex === 3 }"
          @click="activeIndex = 3"
        >
          <div class="card-item__left">
            <div class="left-top" :class="`bg-f${activeIndex > 3 ? '3' : '9'}`">
              <img
                class="left-logo logo-3"
                v-lazy="require('../assets/img/home/partners/gray-3.png')"
                alt="京东"
              />
            </div>
            <div
              class="left-bottom"
              :class="`ba-${activeIndex > 3 ? '6' : '5'}5`"
            >
              京&nbsp;&nbsp;东
            </div>
          </div>
          <div class="card-item__right">
            <div class="right-top">
              <h4 class="right-title">京东</h4>
              <p class="right-desc desc-3">
                京东于2004年正式涉足电商领域，2017年，京东集团市场交易额接近1.3万亿元。2017年7月，京东再次入榜《财富》全球500强，位列第261位，在全球仅次于亚马逊和Alphabet，位列互联网企业第三。2014年5月，京东集团在美国纳斯达克证券交易所正式挂牌上市，是中国第一个成功赴美上市的大型综合型电商平台。2015年7月，京东凭借高成长性入选纳斯达克100指数和纳斯达克100平均加权指数。
              </p>
              <img
                class="right-logo logo-3"
                v-lazy="require('../assets/img/home/partners/logo-3.png')"
                alt="京东"
              />
            </div>
            <div class="right-bottom bga-3"></div>
          </div>
        </div>
        <div
          class="card-item"
          :class="{ active: activeIndex === 4 }"
          @click="activeIndex = 4"
        >
          <div class="card-item__left">
            <div class="left-top" :class="`bg-f${activeIndex > 4 ? '9' : '3'}`">
              <img
                class="left-logo logo-4"
                v-lazy="require('../assets/img/home/partners/gray-4.png')"
                alt="浦发银行"
              />
            </div>
            <div
              class="left-bottom"
              :class="`ba-${activeIndex > 4 ? '7' : '6'}5`"
            >
              浦发银行
            </div>
          </div>
          <div class="card-item__right">
            <div class="right-top">
              <h4 class="right-title">浦发银行</h4>
              <p class="right-desc desc-4">
                上海浦东发展银行股份有限公司是1992年8月28日经中国人民银行批准筹建、1993年1月9日开业、1999年在上海证券交易所挂牌上市（股票v交易代码：600000）的全国性股份制商业银行，总行设在上海。目前，注册资本金293.52亿元。凭借良好的业绩、诚信的声誉，浦发银行成为中国证券市场中备受关注和尊敬的上市公司。
              </p>
              <img
                class="right-logo logo-4"
                v-lazy="require('../assets/img/home/partners/logo-4.png')"
                alt="浦发银行"
              />
            </div>
            <div class="right-bottom bga-4"></div>
          </div>
        </div>
        <div
          class="card-item"
          :class="{ active: activeIndex === 5 }"
          @click="activeIndex = 5"
        >
          <div class="card-item__left">
            <div class="left-top" :class="`bg-f${activeIndex > 5 ? '3' : '9'}`">
              <img
                class="left-logo logo-5"
                v-lazy="require('../assets/img/home/partners/gray-5.png')"
                alt="阿里云"
              />
            </div>
            <div
              class="left-bottom"
              :class="`ba-${activeIndex > 5 ? '8' : '7'}5`"
            >
              阿里云
            </div>
          </div>
          <div class="card-item__right">
            <div class="right-top">
              <h4 class="right-title">阿里云</h4>
              <p class="right-desc desc-5">
                阿里云创立于2009年，是全球领先的云计算及人工智能科技公司，致力于以在线公共服务的方式，提供安全、可靠的计算和数据处理能力，让计算和人工智能成为普惠科技。阿里云服务着制造、金融、政务、交通、医疗、电信、能源等众多领域的企业。在天猫双11全球狂欢节、12306春运购票等极富挑战的应用场景中，阿里云保持着良好的运行纪录。
              </p>
              <img
                class="right-logo logo-5"
                v-lazy="require('../assets/img/home/partners/logo-5.png')"
                alt="阿里云"
              />
            </div>
            <div class="right-bottom bga-5"></div>
          </div>
        </div>
        <div
          class="card-item"
          :class="{ active: activeIndex === 6 }"
          @click="activeIndex = 6"
        >
          <div class="card-item__left">
            <div class="left-top" :class="`bg-f${activeIndex > 6 ? '9' : '3'}`">
              <img
                class="left-logo logo-6"
                v-lazy="require('../assets/img/home/partners/gray-6.png')"
                alt="企业微信"
              />
            </div>
            <div
              class="left-bottom"
              :class="`ba-${activeIndex > 6 ? '9' : '8'}5`"
            >
              企业微信
            </div>
          </div>
          <div class="card-item__right">
            <div class="right-top">
              <h4 class="right-title">企业微信</h4>
              <p class="right-desc desc-6">
                企业微信是腾讯微信团队打造的企业通讯与办公工具，具有与微信一致的沟通体验，丰富的OA应用，和连接微信生态的能力，可帮助企业连接内部、连接生态伙伴、连接消费者。专业协作、安全管理、人即服务。企业微信已覆盖零售、教育、金融、制造业、互联网、医疗等50多个行业，正持续向各行各业输出智慧解决方案。
              </p>
              <img
                class="right-logo logo-6"
                v-lazy="require('../assets/img/home/partners/logo-6.png')"
                alt="企业微信"
              />
            </div>
            <div class="right-bottom bga-6"></div>
          </div>
        </div>
        <div
          class="card-item"
          :class="{ active: activeIndex === 7 }"
          @click="activeIndex = 7"
        >
          <div class="card-item__left">
            <div class="left-top bg-f9">
              <img
                class="left-logo logo-7"
                v-lazy="require('../assets/img/home/partners/gray-7.png')"
                alt="上海斯歌"
              />
            </div>
            <div class="left-bottom ba-95">上海斯歌</div>
          </div>
          <div class="card-item__right">
            <div class="right-top">
              <h4 class="right-title">上海斯歌</h4>
              <p class="right-desc desc-7">
                上海斯歌信息技术有限公司，是一家专业的BPM与云原生PaaS平台服务商。总部位于上海，先后在北京、深圳、成都、武汉、香港、台湾等地设立了分支机构，现有团队人数超300人。公司秉承着“为企业实现业务运营自动化”的使命，致力于为企业客户实现数字化转型与端到端的流程信息化价值，同时在业务赋能、精益管理、运营自动化等方面提供助益。
              </p>
              <img
                class="right-logo logo-7"
                v-lazy="require('../assets/img/home/partners/logo-7.png')"
                alt="上海斯歌"
              />
            </div>
            <div class="right-bottom bga-7"></div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="news-box none"
      v-lazy:background-image="
        newsFirst.backgroundPicture || require('../assets/img/home/news-bg.png')
      "
    >
      <div class="box-content">
        <div
          class="strength-title"
          v-lazy:background-image="require('../assets/img/home/news.png')"
        >
          <div class="text">品牌动态</div>
        </div>
        <div class="clearfix"></div>
        <div class="news-content">
          <img
            @click="toDetails(newsFirst.id)"
            class="news-01"
            :src="newsFirst.coverPicture"
            alt="cover"
          />
          <div class="news-list">
            <div
              class="news-item"
              v-for="item of news"
              :key="item.id"
              @click="toDetails(item.id)"
            >
              <h4 class="news-item__title">{{ item.title }}</h4>
              <div class="news-item__line"></div>
              <div class="news-item__footer">
                <div class="news-item__date">
                  {{ item.publishDate | formatDate }}
                </div>
                <div class="news-item__more"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import Swiper from "swiper"; // 注意引入的是Swiper
import { newList } from "../api/api.js";
export default {
  name: "HomePage",
  data() {
    return {
      showTitle: false,
      mLeft: 0,
      intevalTimer: null,

      solutions: [
        {
          name: "日化",
          img: require("../assets/img/home/solution/1.png")
        },
        {
          name: "酒水",
          img: require("../assets/img/home/solution/2.png")
        },
        {
          name: "食品",
          img: require("../assets/img/home/solution/3.png")
        },
        {
          name: "软饮",
          img: require("../assets/img/home/solution/4.png")
        },
        {
          name: "乳业",
          img: require("../assets/img/home/solution/5.png")
        },
        {
          name: "保健品",
          img: require("../assets/img/home/solution/6.png")
        },
        {
          name: "地产与石化",
          img: require("../assets/img/home/solution/7.png")
        },
        {
          name: "其他",
          img: require("../assets/img/home/solution/8.png")
        }
      ],
      solutionSelected: "日化",
      swiper: null,

      brands: [
        { id: 1, name: "P&G", img: require("../assets/img/home/brand/01.png") },
        {
          id: 2,
          name: "Henkel",
          img: require("../assets/img/home/brand/02.png")
        },
        {
          id: 3,
          name: "科赴",
          img: require("../assets/img/home/brand/03b.png")
        },
        {
          id: 5,
          name: "立白",
          img: require("../assets/img/home/brand/05.png")
        },
        {
          id: 6,
          name: "舒克",
          img: require("../assets/img/home/brand/06.png")
        },
        {
          id: 44,
          name: "花西子",
          img: require("../assets/img/home/brand/44.png")
        },
        {
          id: 7,
          name: "MARS",
          img: require("../assets/img/home/brand/07.png")
        },
        {
          id: 8,
          name: "亿滋",
          img: require("../assets/img/home/brand/08.png")
        },
        {
          id: 9,
          name: "KraftHeinz",
          img: require("../assets/img/home/brand/09.png")
        },
        {
          id: 20,
          name: "健合",
          img: require("../assets/img/home/brand/20.png")
        },
        {
          id: 10,
          name: "李锦记",
          img: require("../assets/img/home/brand/10.png")
        },
        {
          id: 11,
          name: "卫龙",
          img: require("../assets/img/home/brand/11.png")
        },
        {
          id: 15,
          name: "维他奶",
          img: require("../assets/img/home/brand/15.png")
        },
        {
          id: 19,
          name: "伊利",
          img: require("../assets/img/home/brand/19.png")
        },
        {
          id: 17,
          name: "Nestle",
          img: require("../assets/img/home/brand/17.png")
        },
        {
          id: 38,
          name: "光明乳业",
          img: require("../assets/img/home/brand/38.png")
        },
        {
          id: 13,
          name: "Carlslerg",
          img: require("../assets/img/home/brand/13.png")
        },
        {
          id: 14,
          name: "水井坊",
          img: require("../assets/img/home/brand/14.png")
        },
        {
          id: 12,
          name: "汤臣倍健",
          img: require("../assets/img/home/brand/12.png")
        },
        {
          id: 16,
          name: "太古可口可乐",
          img: require("../assets/img/home/brand/16.png")
        },
        {
          id: 21,
          name: "美赞臣",
          img: require("../assets/img/home/brand/21.png")
        },
        {
          id: 22,
          name: "DANONE",
          img: require("../assets/img/home/brand/22.png")
        },
        {
          id: 23,
          name: "惠氏",
          img: require("../assets/img/home/brand/23.png")
        },
        {
          id: 24,
          name: "欧力",
          img: require("../assets/img/home/brand/24.png")
        },
        {
          id: 25,
          name: "PEPSICO",
          img: require("../assets/img/home/brand/25.png")
        },
        {
          id: 37,
          name: "usmile",
          img: require("../assets/img/home/brand/37.png")
        },
        {
          id: 27,
          name: "SASA",
          img: require("../assets/img/home/brand/27.png")
        },
        {
          id: 28,
          name: "VIZ",
          img: require("../assets/img/home/brand/28.png")
        },
        {
          id: 4,
          name: "高露洁",
          img: require("../assets/img/home/brand/04.png")
        },
        {
          id: 29,
          name: "好来",
          img: require("../assets/img/home/brand/29.png")
        },
        {
          id: 18,
          name: "徐福记",
          img: require("../assets/img/home/brand/18.png")
        },
        {
          id: 35,
          name: "格力高",
          img: require("../assets/img/home/brand/35.png")
        },
        {
          id: 33,
          name: "安利",
          img: require("../assets/img/home/brand/33.png")
        },
        {
          id: 26,
          name: "小罐茶",
          img: require("../assets/img/home/brand/26.png")
        },

        {
          id: 30,
          name: "粒上黄",
          img: require("../assets/img/home/brand/30.png")
        },
        {
          id: 36,
          name: "好时",
          img: require("../assets/img/home/brand/36.png")
        },
        {
          id: 31,
          name: "明月镜片",
          img: require("../assets/img/home/brand/31.png")
        },
        {
          id: 45,
          name: "大家乐",
          img: require("../assets/img/home/brand/45.png")
        },
        {
          id: 43,
          name: "箭牌家居",
          img: require("../assets/img/home/brand/43.png")
        },
        {
          id: 34,
          name: "巴黎欧莱雅",
          img: require("../assets/img/home/brand/34.png")
        },

        {
          id: 41,
          name: "豪森药业",
          img: require("../assets/img/home/brand/41.png")
        },
        {
          id: 32,
          name: "贝朗医疗",
          img: require("../assets/img/home/brand/32.png")
        },
        {
          id: 39,
          name: "欧普照明",
          img: require("../assets/img/home/brand/39.png")
        },
        {
          id: 40,
          name: "GILEAD",
          img: require("../assets/img/home/brand/40.png")
        },
        {
          id: 42,
          name: "牛奶国际",
          img: require("../assets/img/home/brand/42.png")
        }
      ],
      brandData: {
        list: [],
        pageNum: 1,
        pageSize: 18,
        pageTotal: 3
      },
      showAll: false,

      activeIndex: 1,

      news: [],
      newsFirst: {},

      showModalBigger: false,
      modalBox: null,
      modalPoint: null,
      modalBigger: null,
      modalBiggerImg: null,

      deadline: 3
    };
  },
  filters: {
    formatDate: function(value) {
      if (!value) {
        return "-";
      }
      const strs = value.split("-");
      return strs[0] + "年" + strs[1] + "月" + strs[2] + "日";
    }
  },
  mounted() {
    scrollTo(0, 0);

    const timer = setTimeout(() => {
      clearTimeout(timer);
      this.showTitle = true;
      this.textSwiper();
      // this.$nextTick(() => {
      //   // 去掉鼠标移入移出暂停切换的效果
      //   this.$refs["carouselRef"].handleMouseEnter = () => {};
      //   this.$refs["carouselRef"].handleMouseLeave = () => {};
      // });
    }, 5100);

    var wow = new WOW();
    wow.init();
    this.onSwiper2();

    this.brandData.list = this.brands.slice(0, 18);

    this.loadNews();

    this.bigger();
  },
  beforeDestroy() {
    if (this.intevalTimer) {
      clearInterval(this.intevalTimer);
    }
  },
  methods: {
    async loadNews() {
      const { data: res } = await newList({
        pageNum: 1,
        pageSize: 5,
        status: 1,
        isHome: 1
      });
      this.newsFirst = res.rows[0];
      // 剩余四个
      this.news = res.rows.slice(1);
    },
    textSwiper() {
      const timer = setTimeout(() => {
        // 获取 swiper-list 的宽度
        const swiperList = document.querySelector(".swiper-list");
        const maxWidth = swiperList.offsetWidth;

        this.intevalTimer = setInterval(() => {
          if (this.mLeft >= maxWidth) {
            this.mLeft = 0;
          }
          this.mLeft += 1;
        }, 16);
      }, 1300);
    },
    onChangeSolution(name, type, i) {
      const item = this.solutions.find(s => s.name === name);
      const index = this.solutions.findIndex(s => s.name === name);
      if (!item) return;

      let _index = i;
      if (type === "prev") {
        if (index > 0) {
          const prev = this.solutions[index - 1];
          this.solutionSelected = prev.name;

          _index = index - 1;
        } else {
          return;
        }
      } else if (type === "next") {
        if (index < this.solutions.length - 1) {
          const next = this.solutions[index + 1];
          this.solutionSelected = next.name;

          _index = index + 1;
        } else {
          return;
        }
      } else {
        this.solutionSelected = item.name;
      }

      this.swiper.slideTo(_index);
    },
    onSwiper2() {
      this.swiper = new Swiper(".solution-swiper", {
        slidesPerView: "auto",
        spaceBetween: 40,
        centeredSlides: true,
        // effect: "coverflow",
        allowSlideClick: false,
        noSwiping: true,
        coverflowEffect: {
          rotate: 30,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }
      });
    },
    goSolution() {
      this.$router.push(`/solutions/cases?c=${this.solutionSelected}`);
    },
    goAbountUs() {
      this.$router.push("/goin/join-us");
    },
    goExhibition() {
     this.$router.push("/goin/contact");
      //const routeData = this.$router.resolve({ path: "/exhibition" });
     //window.open(routeData.href, "_blank");
    },
    goAI() {
      this.$router.push("/products/AI");
      //this.$router.push("/products/AI#one");
    },
    onChangePage(type) {
      if (type === "prev") {
        if (this.brandData.pageNum > 1) {
          this.brandData.pageNum -= 1;
          this.brandData.list = this.brands.slice(
            (this.brandData.pageNum - 1) * this.brandData.pageSize,
            this.brandData.pageNum * this.brandData.pageSize
          );
        }
      } else if (type === "next") {
        if (this.brandData.pageNum < this.brandData.pageTotal) {
          this.brandData.pageNum += 1;
          console.log(
            (this.brandData.pageNum - 1) * this.brandData.pageSize,
            this.brandData.pageNum * this.brandData.pageSize
          );
          this.brandData.list = this.brands.slice(
            (this.brandData.pageNum - 1) * this.brandData.pageSize,
            this.brandData.pageNum * this.brandData.pageSize
          );
        }
      }
    },
    toDetails(id) {
      this.$router.push({
        name: "new",
        query: {
          id
        }
      });
    },
    bigger() {
      this.modalBox = document.querySelector(".modal-box");
      this.modalPoint = document.querySelector(".mask-3a");
      this.modalBigger = document.querySelector(".bigger");
      this.modalBiggerImg = document.querySelector(".bigger-img");

      console.log(
        this.modalBox,
        this.modalPoint,
        this.modalBigger,
        this.modalBiggerImg
      );
    },
    onMouseOverModalBox() {
      this.showModalBigger = true;
    },
    onMouseMoveModalBox(event) {
      //得到的x和y是鼠标在盒子内的坐标  this指向box
      let x = event.pageX - this.modalBox.offsetLeft;
      let y = event.pageY - this.modalBox.offsetTop;

      console.log(x, y);

      //将获取到的鼠标的值给遮罩层（减去一半是因为让鼠标在遮罩层中央） 让它跟着鼠标移动
      let maskX = x - this.modalPoint.offsetWidth / 2;
      let maskY = y - this.modalPoint.offsetHeight / 2;
      let biggerX = x - this.modalBigger.offsetWidth / 2;
      let biggerY = y - this.modalBigger.offsetHeight / 2;

      //设置最大移动距离
      let maskWidth = this.modalBox.offsetWidth - this.modalPoint.offsetWidth;
      let maskHeight =
        this.modalBox.offsetHeight - this.modalPoint.offsetHeight;

      //控制mask移动的范围
      if (maskX <= 0) {
        maskX = 0;
      } else if (maskX >= maskWidth) {
        maskX = maskWidth;
      }

      if (maskY <= 0) {
        maskY = 0;
      } else if (maskY >= maskHeight) {
        maskY = maskHeight;
      }
      this.modalPoint.style.left = maskX + "px";
      this.modalPoint.style.top = maskY + "px";

      //控制bigger移动的范围
      if (biggerX <= 0) {
        biggerX = 0;
      } else if (biggerX >= maskWidth) {
        biggerX = maskWidth;
      }

      if (biggerY <= -60) {
        biggerY = -60;
      } else if (biggerY >= maskHeight - 120) {
        biggerY = maskHeight - 120;
      }
      this.modalBigger.style.left = biggerX + "px";
      this.modalBigger.style.top = biggerY + "px";

      //大图最大移动距离
      let imgWidth =
        this.modalBiggerImg.offsetWidth - this.modalBigger.offsetWidth;
      let imgHeight =
        this.modalBiggerImg.offsetHeight - this.modalBigger.offsetHeight;

      //大图片的移动距离 = mask移动距离 * 大图最大移动距离 / mask的最大移动距离
      let bigX = (maskX * imgWidth) / maskWidth;
      let bigY = (maskY * imgHeight) / maskHeight;

      //赋值
      this.modalBiggerImg.style.left = -bigX + "px";
      this.modalBiggerImg.style.top = -bigY + "px";
    },
    onMouseLeaveModalBox() {
      this.showModalBigger = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.home-container {
  width: 100%;
  background-color: #fafafa;

  .banner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 1080px;
    position: relative;
    background-color: #00094c;

    .video {
      position: absolute;
      width: 100%;
      height: 1080px;
      object-fit: cover;
    }

    .about-us {
      position: absolute;
      top: 320px;
      left: 50%;
      margin-left: -430px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      animation: fade-in 1s ease-in;

      .t1 {
        font-size: 90px;
        line-height: 90px;
        color: #fff;
        font-family: "FontquanXinYiGuanHeiTi-Regular";
        letter-spacing: 16px;
      }

      .t-img {
        width: 939px;
        height: auto;
      }

      .consult {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 442px;
        height: 60px;
        border-radius: 30px;
        color: #d9d9d9;
        font-size: 22px;
        font-family: "MiSans-Normal-";
        background-color: rgba($color: #919191, $alpha: 0.4);
        padding: 0 7px 0 20px;
        margin-top: 54px;

        .custom-input {
          width: 100%;
          height: 100%;
          background-color: transparent;
          border: none;
          color: #ffffff;
          padding: 10px;
        }

        .custom-input::placeholder {
          color: rgba(255, 255, 255, 0.7);
        }

        .call {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 110px;
          height: 46px;
          border-radius: 23px;
          color: #ffffff;
          font-size: 20px;
          font-family: "MiSans-Regular-";
          font-weight: normal;
          //禁止鼠标移入下划线
          text-decoration: none;
          background: linear-gradient(to right, #78eaff 0%, #0145e0 100%);
        }
      }
    }

    .text-swiper {
      position: absolute;
      bottom: 228px;
      width: 1720px;
      height: 72px;
      border-radius: 36px;
      background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0.3) 0%,
        rgba(0, 0, 0, 0.2) 50%,
        rgba(0, 0, 0, 0.3) 100%
      );
      padding: 0 10px;
      animation: fade-in 1s ease-in;
      z-index: 9;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 408px;
        height: 100%;
        border-radius: 36px 0 0 36px;
        background: linear-gradient(
          to right,
          rgba(0, 0, 0, 0.3) 0%,
          rgba(0, 0, 0, 0) 100%
        );
      }

      &::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1;
        width: 408px;
        height: 100%;
        border-radius: 0 36px 36px 0;
        background: linear-gradient(
          to right,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0.3) 100%
        );
      }

      .swiper-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        white-space: nowrap;

        .swiper-list {
          display: flex;
          align-items: center;
        }

        .text-item {
          color: #ded2d7;
          font-size: 24px;
          font-family: "MiSans-Regular-";
          letter-spacing: 1px;
          margin-right: 50px;
        }
      }
    }
  }

  .modal-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    cursor: move;

    .img-1 {
      width: 100%;
      height: auto;
    }

    .mask-3a {
      width: 100px;
      height: 100px;
      // background-color: #999999;
      opacity: 0.5;
      position: absolute;
      top: 0;
      left: 0;
      cursor: move;
    }
  }

  .bigger {
    width: 280px;
    height: 280px;
    border-radius: 50%;
    border: 1px solid #f9f9f9;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    overflow: hidden;

    &-img {
      position: absolute;
      width: 140vw;
    }
  }

  .solution-box {
    width: 100%;
    padding: 108px 0 98px;
    height: 840px;
    margin-top: -100px;
    transform: scale(0.72);
    transform-origin: top;

    .strength-title {
      width: 863px;
      height: 108px;
      background-repeat: no-repeat;
      background-size: contain;
      position: relative;
      .strength-color {
        width: 245px;
        height: 26px;
        border-radius: 13px;
        background-color: #2881ff;
        position: absolute;
        left: 106px;
        top: 55px;
        z-index: 1;
      }
      .text {
        font-size: 49px;
        color: #00094c;
        font-family: "MiSans-Semibold-";
        position: absolute;
        left: 0;
        top: 10px;
        z-index: 9;
        letter-spacing: 8px;
      }
    }

    .condition-box {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 1606px;
      height: 74px;
      color: #ececec;
      font-size: 32px;
      font-family: "MiSans-Normal-";
      font-weight: normal;
      border-radius: 36px;
      background-color: #202329;
      padding: 0 40px;
      margin: 72px auto 50px;

      .condition-item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        cursor: pointer;

        &:nth-child(7) {
          flex: 1.4;
        }

        &.selected {
          font-family: "MiSans-Bold-";
          color: #2880ff;
          position: relative;

          .line {
            position: absolute;
            bottom: 0;
            width: 80%;
            height: 4px;
            background: #005fe2;
            border-radius: 2px 2px 2px 2px;
            transition: left 0.3s;
          }
        }

        &:hover {
          font-family: "MiSans-Bold-";
          color: #2880ff;
        }
      }
    }

    .solution-swiper {
      width: 1646px;
      height: 760px;
      overflow: hidden;
      margin-left: -18px;
    }

    .solution-item {
      display: flex;
      justify-content: space-between;
      width: 1606px;
      height: 720px;
      box-shadow: 0 8px 20px 0px #ebebeb;

      .cover {
        width: 998px;
        height: 100%;
        object-fit: cover;
      }

      &__content {
        flex-shrink: 0;
        width: 580px;
        padding: 80px;
      }

      &__title {
        color: #000735;
        font-size: 67px;
        font-family: "MiSans-DemiBold-";
        line-height: 92px;
      }

      &__btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 228px;
        height: 66px;
        color: #ffffff;
        font-size: 30px;
        font-family: "MiSans-Medium-";
        letter-spacing: 2px;
        border-radius: 33px;
        background-color: #000735;
        margin-top: 100px;
        cursor: pointer;

        .arrow-right {
          width: 18px;
          height: 18px;
          border-top: 3px solid #ffffff;
          border-right: 3px solid #ffffff;
          transform: rotate(45deg);
          margin-left: 10px;
        }
      }

      &__arrow {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 156px;

        .left {
          width: 22px;
          height: 22px;
          border-top: 4px solid #000000;
          border-right: 4px solid #000000;
          transform: rotate(-135deg);
          cursor: pointer;
        }

        .right {
          width: 22px;
          height: 22px;
          border-top: 4px solid #000000;
          border-right: 4px solid #000000;
          transform: rotate(45deg);
          margin-left: 30px;
          cursor: pointer;
        }

        .disabled {
          opacity: 0.3;
          cursor: not-allowed;
        }
      }
    }
  }

  .customers-box {
    width: 100%;
    padding: 98px 0;
    height: 900px;
    transform: scale(0.72);
    transform-origin: top;

    .strength-title {
      float: right;
      width: 1102px;
      height: 130px;
      background-repeat: no-repeat;
      background-size: contain;
      position: relative;
      .strength-color {
        width: 530px;
        height: 26px;
        border-radius: 13px;
        background-color: #2881ff;
        position: absolute;
        left: 288px;
        top: 67px;
        z-index: 1;
      }
      .text {
        font-size: 49px;
        color: #00094c;
        font-family: "MiSans-Semibold-";
        position: absolute;
        right: 0;
        top: 26px;
        z-index: 9;
        letter-spacing: 8px;
      }
    }

    .brand-more {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 196px;
      height: 56px;
      color: #ffffff;
      font-size: 23px;
      font-family: "MiSans-DemiBold-";
      letter-spacing: 4px;
      border-radius: 28px;
      background-color: #202329;
      background-size: contain;
      padding: 0 7px 0 27px;
      margin: 47px 0 43px;
      cursor: pointer;
    }

    .brand-list {
      display: flex;
      flex-wrap: wrap;
    }

    .brand-item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 248px;
      height: 122px;
      background: #ffffff;
      box-shadow: 0px 11px 20px 0px #e2e2e2;
      margin: 0 22px 22px 0;

      &:nth-child(6n) {
        margin-right: 0;
      }

      &__img {
        display: block;
        object-fit: cover;
      }

      .brand-logo-1 {
        width: 156px;
        height: 69px;
      }
      .brand-logo-2 {
        width: 144px;
        height: 81px;
      }
      .brand-logo-3 {
        width: 195px;
        height: 81px;
      }
      .brand-logo-4 {
        width: 198px;
        height: 66px;
      }
      .brand-logo-5 {
        width: 124px;
        height: 63px;
      }
      .brand-logo-6 {
        width: 168px;
        height: 69px;
      }
      .brand-logo-7 {
        width: 197px;
        height: 56px;
      }
      .brand-logo-8 {
        width: 161px;
        height: 76px;
      }
      .brand-logo-9 {
        width: 216px;
        height: 36px;
      }
      .brand-logo-10 {
        width: 109px;
        height: 81px;
      }
      .brand-logo-11 {
        width: 148px;
        height: 88px;
      }
      .brand-logo-12 {
        width: 162px;
        height: 49px;
      }
      .brand-logo-13 {
        width: 178px;
        height: 73px;
      }
      .brand-logo-14 {
        width: 55px;
        height: 83px;
      }
      .brand-logo-15 {
        width: 142px;
        height: 68px;
      }
      .brand-logo-16 {
        width: 219px;
        height: 57px;
      }
      .brand-logo-17 {
        width: 76px;
        height: 76px;
      }
      .brand-logo-18 {
        width: 83px;
        height: 84px;
      }
      .brand-logo-19 {
        width: 106px;
        height: 81px;
      }
      .brand-logo-20 {
        width: 213px;
        height: 57px;
      }
      .brand-logo-21 {
        width: 181px;
        height: 76px;
      }
      .brand-logo-22 {
        width: 71px;
        height: 84px;
      }
      .brand-logo-23 {
        width: 227px;
        height: 43px;
      }
      .brand-logo-24 {
        width: 83px;
        height: 80px;
      }
      .brand-logo-25 {
        width: 228px;
        height: 54px;
      }
      .brand-logo-26 {
        width: 152px;
        height: 72px;
      }
      .brand-logo-27 {
        width: 138px;
        height: 77px;
      }
      .brand-logo-28 {
        width: 106px;
        height: 79px;
      }
      .brand-logo-29 {
        width: 186px;
        height: 72px;
      }
      .brand-logo-30 {
        width: 93px;
        height: 86px;
      }
      .brand-logo-31 {
        width: 185px;
        height: 56px;
      }
      .brand-logo-32 {
        width: 174px;
        height: 72px;
      }
      .brand-logo-33 {
        width: 149px;
        height: 78px;
      }
      .brand-logo-34 {
        width: 158px;
        height: 68px;
      }
      .brand-logo-35 {
        width: 166px;
        height: 72px;
      }
      .brand-logo-36 {
        width: 175px;
        height: 64px;
      }
      .brand-logo-37 {
        width: 160px;
        height: 53px;
      }
      .brand-logo-38 {
        width: 200px;
        height: 51px;
      }
      .brand-logo-39 {
        width: 129px;
        height: 54px;
      }
      .brand-logo-40 {
        width: 186px;
        height: 69px;
        margin-top: 20px;
      }
      .brand-logo-41 {
        width: 164px;
        height: 49px;
      }
      .brand-logo-42 {
        width: 110px;
        height: 72px;
      }
      .brand-logo-43 {
        width: 156px;
        height: 69px;
      }
      .brand-logo-44 {
        width: 200px;
        height: 58px;
      }
      .brand-logo-45 {
        width: 200px;
        height: 91px;
      }
    }

    .page {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 60px 0 30px;
      margin: 0 auto;

      .left {
        display: flex;
        align-items: flex-end;
        font-family: "Anton-Regular";
        font-weight: bold;
        letter-spacing: 2px;

        .current {
          font-size: 49px;
          color: #202329;
          line-height: 49px;
        }
        .total {
          font-size: 37px;
          color: #2656b3;
          line-height: 37px;
        }
      }
      .middle {
        flex: 1;
        display: flex;
        margin: 0 59px;

        span {
          flex: 1;
          height: 4px;
          background-color: #cccccc;

          &.selected {
            background-color: #202329;
          }
        }
      }
      .right {
        display: flex;

        span {
          width: 113px;
          height: 46px;
          border-radius: 21px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          &.prev {
            border: 1px solid #202329;
          }

          &.next {
            margin-left: 10px;
            background-color: #202329;
          }
        }

        img {
          width: 12px;
          height: 20px;
        }
      }
    }

    .popup {
      position: fixed;
      top: calc(40% - 280px);
      left: 0;
      z-index: 9999;
      width: 100%;
      height: 1030px;
      background-color: rgba(0, 0, 0, 0.9);
      padding-top: 110px;
      animation: fly-in 0.5s forwards;

      .brand-item {
        height: 88px;
        box-shadow: none;

        img {
          transform: scale(0.8);
        }
      }

      .brand-item-more {
        display: flex;
        justify-content: center;
        align-items: center;
        //flex: 1;
        width: 248px;
        height: 88px;
        color: #ffffff;
        font-size: 36px;
        font-family: "MiSans-Demibold-";
        letter-spacing: 2px;
        background-color: #1d55de;
        text-decoration: none;
        margin-right: 8px;
        cursor: pointer;

        .arrow-left {
          width: 22px;
          height: 22px;
          border-bottom: 4px solid #ffffff;
          border-left: 4px solid #ffffff;
          transform: rotate(45deg);
          margin-right: 16px;
        }
      }
    }
  }

  .partners-box {
    width: 100%;
    height: 1076px;
    padding: 98px 0;
    background-repeat: no-repeat;
    background-size: cover;
    transition: all 0.8s;

    .strength-title {
      width: 672px;
      height: 93px;
      background-repeat: no-repeat;
      background-size: contain;
      margin-top: 108px;
      position: relative;
      transform: scale(0.72);
      transform-origin: bottom;
      margin-left: 130px;

      .strength-color {
        width: 354px;
        height: 26px;
        border-radius: 13px;
        position: absolute;
        left: -13px;
        top: 47px;
        z-index: 1;
        transition: all 0.5s;

        &.bc-1 {
          background-color: #2881ff;
        }
        &.bc-2 {
          background-color: #825d0b;
        }
        &.bc-3 {
          background-color: #e50013;
        }
        &.bc-4 {
          background-color: #2881ff;
        }
        &.bc-5 {
          background-color: #ff6702;
        }
        &.bc-6 {
          background-color: #2881ff;
        }
        &.bc-7 {
          background-color: #80ad41;
        }
      }
      .text {
        font-size: 49px;
        color: #ffffff;
        font-family: "MiSans-Semibold-";
        position: absolute;
        left: 0;
        top: 2px;
        z-index: 9;
        letter-spacing: 8px;
      }
    }

    .card {
      display: flex;
      align-items: center;
      height: 445px;
      overflow: hidden;
      margin-top: 80px;
      margin-left: 380px;

      &-item {
        display: flex;
        align-items: center;
        width: 88px;
        height: 100%;
        overflow: hidden;
        transition: all 1s;

        &.active {
          width: 760px;

          .card-item__left {
            margin-left: -88px;
          }
        }

        &__left {
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          width: 88px;
          height: 100%;
          margin-left: 0;
          cursor: pointer;
          transition: all 1s;

          .left-top {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.5s;
            position: relative;

            &::after {
              content: "+";
              display: flex;
              align-items: center;
              justify-content: center;
              width: 54px;
              height: 54px;
              color: #a6a6a6;
              font-size: 36px;
              font-family: "MiSans-Normal-";
              letter-spacing: 0;
              border-radius: 50%;
              background-color: #ffffff;
              box-shadow: 0 8px 28px 0px #ebebeb;
            }

            &.bg-f3 {
              background-color: #f3f3f3;
            }

            &.bg-f9 {
              background-color: #f9f9f9;
            }
          }

          .left-logo {
            height: auto;
            position: absolute;

            &.logo-1 {
              right: 0;
              bottom: 21px;
              width: 55px;
            }
            &.logo-2 {
              top: 15px;
              right: 0;
              width: 50px;
            }
            &.logo-3 {
              right: 0;
              bottom: 20px;
              width: 71px;
            }
            &.logo-4 {
              top: 26px;
              right: 0;
              width: 61px;
            }
            &.logo-5 {
              right: 0;
              bottom: 29px;
              width: 62px;
            }
            &.logo-6 {
              top: 26px;
              right: 0;
              width: 64px;
            }
            &.logo-7 {
              right: 0;
              bottom: 24px;
              width: 48px;
            }
          }

          .left-bottom {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 55px;
            color: #ffffff;
            font-size: 18px;
            font-family: "MiSans-Light-";
            transition: all 0.5s;

            &.ba-45 {
              background: rgba($color: #0d1110, $alpha: 0.45);
            }
            &.ba-55 {
              background: rgba($color: #0d1110, $alpha: 0.55);
            }
            &.ba-65 {
              background: rgba($color: #0d1110, $alpha: 0.65);
            }
            &.ba-75 {
              background: rgba($color: #0d1110, $alpha: 0.75);
            }
            &.ba-85 {
              background: rgba($color: #0d1110, $alpha: 0.85);
            }
            &.ba-95 {
              background: rgba($color: #0d1110, $alpha: 0.95);
            }
          }
        }

        &__right {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 760px;
          height: 100%;

          .right-top {
            flex: 1;
            display: flex;
            flex-direction: column;
            background: rgba($color: #ffffff, $alpha: 0.95);
            position: relative;
          }

          .right-logo {
            height: auto;
            position: absolute;

            &.logo-1 {
              top: 53px;
              left: 633px;
              width: 74px;
            }
            &.logo-2 {
              top: 47px;
              left: 634px;
              width: 74px;
            }
            &.logo-3 {
              top: 49px;
              left: 631px;
              width: 76px;
            }
            &.logo-4 {
              top: 44px;
              left: 615px;
              width: 93px;
            }
            &.logo-5 {
              top: 56px;
              left: 609px;
              width: 97px;
            }
            &.logo-6 {
              top: 56px;
              left: 626px;
              width: 83px;
            }
            &.logo-7 {
              top: 53px;
              left: 628px;
              width: 79px;
            }
          }

          .right-title {
            width: 300px;
            color: #000735;
            font-size: 33px;
            font-family: "MiSans-Demibold-";
            letter-spacing: 2px;
            margin-top: 68px;
            margin-left: 52px;
          }

          .right-desc {
            width: 648px;
            color: #000735;
            font-size: 21px;
            font-family: "MiSans-Light-";
            text-align: justify;
            margin-left: 52px;
            margin-bottom: 0;
            line-height: 31px;

            &.desc-1 {
              font-size: 22px;
              margin-top: 80px;
              line-height: 36px;
            }
            &.desc-2 {
              margin-top: 50px;
            }
            &.desc-3 {
              margin-top: 50px;
            }
            &.desc-4 {
              margin-top: 80px;
            }
            &.desc-5 {
              margin-top: 50px;
            }
            &.desc-6 {
              margin-top: 80px;
            }
            &.desc-7 {
              margin-top: 50px;
            }
          }

          .right-bottom {
            flex-shrink: 0;
            width: 100%;
            height: 55px;
            transition: all 0.5s;

            &.bga-1 {
              background: rgba($color: #103b88, $alpha: 0.95);
            }
            &.bga-2 {
              background: rgba($color: #103b88, $alpha: 0.95);
            }
            &.bga-3 {
              background: rgba($color: #e50013, $alpha: 0.95);
            }
            &.bga-4 {
              background: rgba($color: #015a9a, $alpha: 0.95);
            }
            &.bga-5 {
              background: rgba($color: #ff6702, $alpha: 0.95);
            }
            &.bga-6 {
              background: rgba($color: #0381ec, $alpha: 0.95);
            }
            &.bga-7 {
              background: rgba($color: #80ad41, $alpha: 0.95);
            }
          }
        }
      }
    }
  }

  .news-box {
    width: 100%;
    height: 1087px;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 168px 0;

    .strength-title {
      float: right;
      width: 472px;
      height: 112px;
      background-repeat: no-repeat;
      background-size: contain;
      position: relative;
      transform: scale(0.72);
      transform-origin: bottom;
      margin-right: 170px;
      .text {
        font-size: 49px;
        color: #ffffff;
        font-family: "MiSans-Semibold-";
        position: absolute;
        right: 0;
        top: 22px;
        z-index: 9;
        letter-spacing: 8px;
      }
    }

    .news-content {
      display: flex;
      transform: scale(0.72);
    }

    .news-01 {
      width: 468px;
      height: 679px;
      margin-right: 6px;
      cursor: pointer;
    }

    .news-list {
      display: flex;
      flex-wrap: wrap;
    }

    .news-item {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 530px;
      background: #ffffff;
      padding: 44px 35px;
      margin: 0 0 25px 30px;
      cursor: pointer;

      &__title {
        width: 458px;
        height: 98px;
        color: #00094c;
        font-size: 25px;
        font-family: "MiSans-Regular-";
        line-height: 34px;
        // 超过三行展示...
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        margin: 0;
      }

      &__line {
        width: 100%;
        height: 2px;
        background-color: #202329;
        margin: 76px 0 24px;
      }

      &__footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
      }

      &__date {
        color: #00094c;
        font-size: 26px;
        font-weight: 400;
        font-family: "MiSans-Demibold-";
      }

      &__more {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 2px;
        background-color: #00094c;
        position: relative;

        &::before {
          content: "";
          position: absolute;
          right: 0;
          width: 14px;
          height: 14px;
          border-top: 3px solid #00094c;
          border-right: 3px solid #00094c;
          transform: rotate(45deg);
        }
      }
    }
  }

  .box-content {
    width: 1606px;
    margin: 0 auto;
  }
}

.clearfix {
  clear: both;
}

/* 定义动画 */
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes moveUpDown {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-36px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes fly-in {
  0% {
    transform: translateX(-600px) translateY(-280px) scale(0);
    opacity: 0.5;
  }
  100% {
    transform: translateX(0) translateY(0) scale(1);
    opacity: 1;
  }
}
.indexBanner {
  // position: absolute;
  // top: 0;
  // left: 0;
  width: 100%;
  height: 1080px;
  //background: #015a9a;
  .banner1 {
    width: 1920px;
    height: 1080px;
    background: url("../assets/img/home/banner1.png") no-repeat;
    background-size: 100% 100%;
    cursor: pointer;

    .bannerContent {
      position: relative;

      .slogan {
        padding-left: 360px;
        padding-top: 230px;

        p {
          font-size: 72px;
          color: #ffffff;

          span {
            font-size: 36px;
            margin-left: 30px;
          }
        }

        .line {
          margin-top: 100px;
          width: 160px;
          height: 2px;
          background: #fff;
        }

        .explain {
          position: relative;
          margin-top: 80px;
          width: 750px;
          font-size: 22px;
          line-height: 1.8;
          color: #ffffff;

          &::before {
            position: absolute;
            top: -25px;
            left: 0;
            content: "";
            width: 36px;
            height: 2px;
            background: #fff;
          }
        }

        .button {
          margin-top: 100px;
          border-radius: 8px;
          position: absolute;
          width: 200px;
          height: 48px;
          line-height: 48px;
          text-align: center;
          font-size: 16px;
          color: #fff;
          background-image: -moz-linear-gradient(
            125deg,
            rgb(254, 78, 85) 0%,
            rgb(254, 103, 77) 64%,
            rgb(254, 128, 69) 100%
          );
          background-image: -webkit-linear-gradient(
            125deg,
            rgb(254, 78, 85) 0%,
            rgb(254, 103, 77) 64%,
            rgb(254, 128, 69) 100%
          );
          background-image: -ms-linear-gradient(
            125deg,
            rgb(254, 78, 85) 0%,
            rgb(254, 103, 77) 64%,
            rgb(254, 128, 69) 100%
          );
          box-shadow: 0px 7px 24px 0px rgba(64, 21, 89, 0.2);
          cursor: pointer;
          transition: 0.5s all;

          &:hover {
            background-image: none;
            border: 1px solid #fff;
            color: #fff;
          }
        }
      }

      .picture {
        position: absolute;
        right: 10%;
        top: 0%;
        margin-top: 200px;
        //animation: Tadas1 3s infinite linear;

        img {
          width: 630px;
          height: 521px;
        }
      }
    }
  }
  .banner2 {
    width: 1920px;
    height: 1080px;
    background: url("../assets/img/home/banner2.png") no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
  }
  .banner {
    //width: 1920px;
    height: 1080px;
    background: url("../assets/img/home/banner.png") no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
  }
  /deep/ .el-carousel__indicators--horizontal {
    top: 720px;
    left: 50%;
    transform: translateX(-50%);
  }
  /deep/ .el-carousel__button {
    width: 20px;
    height: 4px;
    background: #fff;
  }
}
.el-carousel--horizontal {
  overflow: hidden;
}
/* 设置carousel-item的样式，确保淡入淡出有效果 */
.el-carousel__item {
  opacity: 1;
  //transition: all 1s ease-in-out;
  // animation: fade-in 0.6s ease;
}
.el-carousel__item.is-active {
  opacity: 1;
}
.el-carousel__item.is-animating {
  transition: opacity 1s ease-in-out !important;
}

/* 定义动画 */
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.box{
height: 300px;
display: block;
background: red;
}
</style>
s


// WEBPACK FOOTER //
// src/view/HomePage.vue